import { ApolloProvider } from '@trello/graphql';
import React, { Suspense, useCallback } from 'react';
import { useLazyComponent } from '@trello/use-lazy-component';
import { ErrorBoundary } from 'app/src/components/ErrorBoundary';
import { ChunkLoadErrorBoundary } from 'app/src/components/ChunkLoadErrorBoundary';
import { BoardShareButton } from './BoardShareButton';
import Dialog from 'app/scripts/views/lib/dialog';
import {
  LazyBoardInviteModal,
  dialogProps,
} from 'app/src/components/BoardInviteModal';

export const LazyBoardShareSpotlight: React.FunctionComponent<{
  idBoard: string;
  idOrg: string;
}> = ({ idBoard, idOrg }) => {
  const BoardShareSpotlight = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "board-share-spotlight" */ './BoardShareSpotlight'
      ),
    { preload: false, namedImport: 'BoardShareSpotlight' },
  );

  const openBoardShareModal = useCallback(() => {
    Dialog.show({
      reactElement: (
        <LazyBoardInviteModal
          idBoard={idBoard}
          idOrg={idOrg}
          onClose={Dialog.hide}
        />
      ),
      ...dialogProps,
    });
  }, [idBoard, idOrg]);

  const boardShareButton = (
    <BoardShareButton onClickButton={openBoardShareModal} />
  );

  return (
    <Suspense fallback={null}>
      <ErrorBoundary
        tags={{
          ownershipArea: 'trello-smoothie',
          feature: 'Board Share Spotlight',
        }}
      >
        <ChunkLoadErrorBoundary fallback={boardShareButton}>
          <ApolloProvider>
            <BoardShareSpotlight idBoard={idBoard} idOrg={idOrg} />
          </ApolloProvider>
        </ChunkLoadErrorBoundary>
      </ErrorBoundary>
    </Suspense>
  );
};
